export { default } from './ErrorBlock'
